export const REPORT_HISTORY_API =
  "https://7gosq172ec.execute-api.us-east-1.amazonaws.com/dev/amplifye/event-reports";
export const GENERATE_API =
  "https://7gosq172ec.execute-api.us-east-1.amazonaws.com/dev/amplifye/event_details";
export const RECORDS_PER_PAGE = 10;
